import React, { useState } from 'react'
import Dropdown from '../../../components/Dropdown'
import GenericModal from '../../../components/GenericModal'
import CreateAndEditCourseCatalog from '../CreateNewCourseCatalog'
import { useAppDispatch } from '../../../store'
import { getDivisionCoursesApi } from '../../../store/slices/courseCatalogSlice/api'
import { TableModalAction, type ApplyFiltersAndDispatchParams } from '../../../components/CustomTable/types'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import { notification } from '../../../components/Notifications'

interface CoursesCatalogTopbarActionsProps {
  params?: ApplyFiltersAndDispatchParams
  allowedActions?: string[]
  setUploadTaskId: (id: string | null) => void
  isTaskRunning: boolean
  onTaskBlock: () => void
}

const CoursesCatalogTopbarActions: React.FC<CoursesCatalogTopbarActionsProps> = ({ params, allowedActions, setUploadTaskId, isTaskRunning, onTaskBlock }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
  }

  const uploadApi = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsUploadModal(true)
  }

  const addManually = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsCreateModal(true)
  }

  const menuItems = [
    { text: 'Upload Courses (.csv)', action: uploadApi },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      {allowedActions?.includes(TableModalAction.CREATE) && <Dropdown menuItems={menuItems} label='Add Courses' />}
      <GenericModal
        isOpen={isCreateModal}
        title={'Create Course '}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditCourseCatalog handleCloseModal={() => { setIsCreateModal(false) }} params={params} />
      </GenericModal>

      <CsvMappingUpload csvHeaderEndpoint="/api/divisions/csv_headers" isOpen={isUploadModal} modalTitle="Courses" onClose={closeUploadModal} uploadCsvEndpoint="/api/divisions/?category_name=Course" hasCreatePermission={allowedActions?.includes(TableModalAction.CREATE)} returnTaskId={(id) => { if (id) setUploadTaskId(id) }} onSuccess={() => {
        notification('Courses successfully uploaded', { variant: 'success' })
        void dispatch(getDivisionCoursesApi({ params }))
      }} />
    </>
  )
}

export default CoursesCatalogTopbarActions
